module.exports = __webpack_public_path__ + "static/img/product05-1.52a36ac8.png";